import { useDetailsResource } from 'framework/ViewTypes/hooks';
import { useTechnologyService } from 'domain/shared/career';
import { usePositionService } from 'domain/shared/employee';
import usePositionProfilesService from '../../usePositionProfilesService';
import { mapPositionProfileDetails } from './positionProfileDetailsMapper';

const usePositionProfileDetails = (id?: string) => {
  const { getById } = usePositionProfilesService();
  const { findAll: findAllPositions } = usePositionService();
  const { findAll: findAllTechnologies } = useTechnologyService();
  const { data: profile, ...state } = useDetailsResource(id, async profileId => {
    const [positionProfile, positions, technologies] = await Promise.all([
      getById(profileId),
      findAllPositions().catch(() => []),
      findAllTechnologies().catch(() => []),
    ]);

    return mapPositionProfileDetails(positionProfile, positions, technologies);
  });

  return { profile, ...state };
};

export default usePositionProfileDetails;
